import classNames from 'classnames';
import { array, bool, func, number, object, string, shape } from 'prop-types';
import React, { useContext, useCallback } from 'react';
import { Input } from '@eika/input';
import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import DropDown from '../../../drop-down';
import connect from '../../helper/connect';
import getLabel from '../labels';
import CountryContext from '../../../country-context';
import ErrorMessage from '../../errormessage';

function InternasjonaleOverforing(props) {
    const { question, context, tilUtland, index, errors, onChange, ekstratekster } = props;
    const onRemove = () => props.onRemove(question.id);

    const countryContext = useContext(CountryContext);

    const updateField = useCallback(
        (key, dataKey = 'value') =>
            (event) => {
                onChange(question.id, {
                    [key]: event.target[dataKey],
                });
            },
        [onChange, question.id]
    );

    const selectCountry = useCallback(
        () => (value) => {
            onChange(question.id, {
                land: value,
            });
        },
        [onChange, question.id]
    );

    const removeCountry = useCallback(
        () => () => {
            onChange(question.id, {
                land: null,
            });
        },
        [onChange, question.id]
    );

    const hasInvalid = (name) =>
        (context.getHasSubmitted() || context.touched(`${name}_${question.id}`)) && errors.includes(name);

    const transaksjonerOptions = countryContext.getTransaksjonerOptions();

    const labelPrefix = tilUtland ? 'overfore' : 'motta';

    return (
        <div className="crs-answer">
            <IconButton className="sgw-button removeicon" onClick={onRemove} icon={IconTypes.KRYSS_24} />
            <div className="extra-large-margin-top">
                <DropDown
                    id="crs-hvilket-land"
                    values={transaksjonerOptions}
                    selected={question.land}
                    name="land"
                    selectValue={selectCountry()}
                    label={getLabel(ekstratekster, `${labelPrefix}_land`)}
                    className="extra-large-margin-top"
                    removeValue={removeCountry()}
                    onBlur={() => context.updateValidation(`land_${question.id}`, true, hasInvalid('land'))}
                    customDropDownWidthClass="drop-down-list-width-77-percent"
                />
                {hasInvalid('land') && <ErrorMessage text={getLabel(ekstratekster, 'land_instruks')} />}
            </div>

            <div className={classNames('extra-large-margin-top', { 'has-error error': hasInvalid('hvorfor') })}>
                <h2 className="skjema-input-question">{getLabel(ekstratekster, `${labelPrefix}_hvorfor`)}</h2>
                <Input
                    onChange={updateField('hvorfor')}
                    type="text"
                    name="hvorfor"
                    id={`hvorfor_${index}`}
                    value={question.hvorfor || ''}
                    className="form-control crs-skattenummer"
                    onBlur={() => context.updateValidation(`hvorfor_${question.id}`, true, hasInvalid('hvorfor'))}
                />
            </div>
            {hasInvalid('hvorfor') && <ErrorMessage text={getLabel(ekstratekster, 'hvorfor_instruks')} />}

            <div className={classNames('extra-large-margin-top', { 'has-error error': hasInvalid('belop') })}>
                <h2 className="skjema-input-question">{getLabel(ekstratekster, `${labelPrefix}_belop`)}</h2>
                <Input
                    // TODO: Use new CurrencyInput-component if supposed to...
                    // <Cleave
                    // <CurrencyInput
                    onBlur={() => context.updateValidation(`belop_${question.id}`, true, hasInvalid('belop'))}
                    aria-label={getLabel(ekstratekster, `${labelPrefix}_belop`)}
                    type="number"
                    onChange={updateField('belop')}
                    name="belop"
                    className="form-control crs-skattenummer"
                    id={`belop_${index}`}
                    value={question.belop || ''}
                    inputMode="decimal"
                />
            </div>
            {hasInvalid('belop') && <ErrorMessage text={getLabel(ekstratekster, 'belop_instruks')} />}

            <div className={classNames('extra-large-margin-top', { 'has-error error': hasInvalid('antOverforinger') })}>
                <h2 className="skjema-input-question">{getLabel(ekstratekster, `${labelPrefix}_antall`)}</h2>
                <Input
                    onChange={updateField('antOverforinger')}
                    name="antOverforinger"
                    className="form-control crs-skattenummer"
                    id={`antOverforinger_${index}`}
                    value={question.antOverforinger || ''}
                    type="number"
                    onBlur={() =>
                        context.updateValidation(`antOverforinger_${question.id}`, true, hasInvalid('antOverforinger'))
                    }
                    inputMode="decimal"
                />
            </div>
            {hasInvalid('antOverforinger') && <ErrorMessage text={getLabel(ekstratekster, 'antall_instruks')} />}
        </div>
    );
}

InternasjonaleOverforing.propTypes = {
    context: object,
    errors: array.isRequired,
    index: number,
    onChange: func,
    onRemove: func,
    question: object.isRequired,
    tilUtland: bool.isRequired,
    ekstratekster: shape({
        overfore_land: string,
        overfore_belop: string,
        overfore_antall: string,
        overfore_hvorfor: string,
        overfore_flere: string,
        motta_land: string,
        motta_belop: string,
        motta_antall: string,
        motta_hvorfor: string,
        motta_flere: string,
        land_instruks: string,
        belop_instruks: string,
        antall_instruks: string,
        hvorfor_instruks: string,
    }).isRequired,
};

export default connect(InternasjonaleOverforing);
